/**
 * When GRI runs inside a cross-origin iframe, the child cannot read or set the parent URL.
 * Ask the host shell (e.g. Fusion) to navigate home and drop modulePath so refresh stays correct.
 *
 * Parent should listen for message events and validate origin, e.g.:
 *   window.addEventListener('message', (e) => {
 *     if (e.data?.source === 'gri-fe' && e.data?.type === GRI_POST_MESSAGE_REGULATIONS_NEXT_HOME) {
 *       // clear modulePath from address bar and load Regulations Next list
 *     }
 *   });
 */
export const GRI_POST_MESSAGE_REGULATIONS_NEXT_HOME =
  "gri-fe.regulations-next-home" as const;

export function postRegulationsNextHomeToParent(): void {
  try {
    if (window.parent === window.self) return;

    // For cross-origin iframes we cannot read parent location directly.
    // `document.referrer` is the parent page URL in most embedded scenarios.
    const targetOrigin = (() => {
      try {
        const ref = document.referrer;
        if (!ref) return null;
        return new URL(ref).origin;
      } catch {
        return null;
      }
    })();

    // If we can't determine a safe target origin, don't broadcast to "*".
    if (!targetOrigin) return;

    window.parent.postMessage(
      {
        source: "gri-fe",
        type: GRI_POST_MESSAGE_REGULATIONS_NEXT_HOME,
        clearModulePath: true,
      },
      targetOrigin,
    );
  } catch {
    /* noop */
  }
}
